import { useState, FC } from 'react'
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser'
import styles from './Careers.module.scss'
import { openPositions } from './openPositions'
import Image from 'next/image'
import classNames from 'classnames'
import heroImage from '../../../public/images/features/careers/team.jpg'
import { TITLE_POSTFIX } from 'constants/seo'

export const Careers: FC = () => {
  // i18n
  const { t } = useTranslation(['careers', 'about'])

  // Local state
  const [selectedJob, setSelectedJob] = useState(0)

  return (
    <>
      {/* SEO */}
      <Head>
        <title>
          {t('title')} {TITLE_POSTFIX}
        </title>
        <meta property="og:title" content={`${t('title')} ${TITLE_POSTFIX}`} key="title" />
      </Head>

      <div className={styles.careers}>
        {/* HERO IMAGE */}
        <section className={classNames('section', styles.hero)}>
          <Image
            priority
            src={heroImage}
            layout="fill"
            objectFit="cover"
            objectPosition="center 30%"
            placeholder="blur"
            alt="Team Bolt Energie"
          />
        </section>

        {/* CAREERS */}
        <section className={classNames('section', 'is-dark', styles['jobs-wrapper'])}>
          <div className="container">
            <h1 className={styles.title}>{t('title', 'Vacatures bij Bolt')}</h1>
            <div className={styles.jobs}>
              {openPositions.map((job, idx) => (
                <div key={`job-${idx}`} className={classNames({ [styles.selected]: selectedJob === job.id })}>
                  <div className={styles.job}>
                    <button onClick={() => setSelectedJob(selectedJob === job.id ? 0 : job.id)}>
                      <div className={styles['job-title']}>
                        <span>{job.title}</span>
                        <div className={styles['icon-container']}>
                          <Image src="/images/common/collapse.png" width={30} height={30} alt="Collapse job" />
                        </div>
                      </div>
                      <div onClick={(e) => e.stopPropagation()} className={styles['job-content']} role="presentation">
                        {job.description}
                      </div>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ABOUT */}
        <section className={classNames('section', styles.about)}>
          <div className="container">
            <div className={styles.intro}>
              <p className={classNames(styles.subtitle, 'margin-bottom-s', 'margin-top-none')}>
                {t('about:videoSubtitle', 'Een vernieuwend peer-to-peer model')}
              </p>
              <h2 className={classNames(styles.title, 'margin-top-none', 'margin-bottom-l')}>
                {t('about:videoTitle', 'Bolt wil de energiemarkt veranderen!')}
              </h2>
              <div className={styles.description}>
                {parse(
                  t(
                    'about:videoText',
                    'Het is soms moeilijk te begrijpen waar onze energie juist vandaan komt. Met Bolt willen we consumenten en lokale groene producenten dichter bij elkaar brengen. Zo wordt de markt een pak ondubbelzinniger: iedereen zal exact weten waar zijn groene energie vandaan komt. Op die manier kunnen we samen duidelijk maken dat we vinden dat groene energie lokaal en transparant moet worden opgewekt. We dromen van een België waar iedereen in alle openheid energie van elkaar kan afnemen.'
                  )
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}

export default Careers
